export default "__VITE_ASSET__DLwNp4QN__"